var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "financeCalculator" },
    [
      _c("div", { staticClass: "financeCalculator__body" }, [
        _c(
          "div",
          { staticClass: "financeCalculator__form" },
          [
            _c(
              "div",
              { staticClass: "financeCalculator__form__fields" },
              [
                _c(
                  "FinanceCalculatorRow",
                  {
                    attrs: {
                      id: "financeType",
                      label: " What do you want to finance?",
                    },
                  },
                  [
                    _c("FinanceCalculatorSelect", {
                      attrs: { id: "financeType", options: _vm.financeOptions },
                      model: {
                        value: _vm.params.financeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "financeType", $$v)
                        },
                        expression: "params.financeType",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FinanceCalculatorRow",
                  { attrs: { id: "vehicleType", label: "Vehicle price" } },
                  [
                    _c("FinanceCalculatorRange", {
                      attrs: {
                        id: "vehiclePrice",
                        min: 2000,
                        max: 100000,
                        "default-value": _vm.params.price,
                        formatter: _vm.formatCurrency,
                      },
                      model: {
                        value: _vm.params.price,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "price", $$v)
                        },
                        expression: "params.price",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FinanceCalculatorRow",
                  { attrs: { id: "deposit", label: "Deposit amount" } },
                  [
                    _c("FinanceCalculatorRange", {
                      attrs: {
                        id: "deposit",
                        min: 0,
                        max: 10000,
                        step: 200,
                        "default-value": _vm.params.deposit,
                        formatter: _vm.formatCurrency,
                      },
                      model: {
                        value: _vm.params.deposit,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "deposit", $$v)
                        },
                        expression: "params.deposit",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FinanceCalculatorRow",
                  { attrs: { id: "term", label: "Finance term" } },
                  [
                    _c("FinanceCalculatorRange", {
                      attrs: {
                        id: "term",
                        min: 1,
                        max: 60,
                        step: 6,
                        "default-value": _vm.params.term,
                        formatter: _vm.formatTerms,
                      },
                      model: {
                        value: _vm.params.term,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "term", $$v)
                        },
                        expression: "params.term",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FinanceCalculatorRow",
                  {
                    attrs: {
                      id: "creditScore",
                      label: "Estimated credit score*",
                    },
                  },
                  [
                    _c("FinanceCalculatorSelect", {
                      attrs: {
                        id: "creditScore",
                        options: _vm.creditScoreOptions,
                      },
                      model: {
                        value: _vm.params.creditScore,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "creditScore", $$v)
                        },
                        expression: "params.creditScore",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("FinanceCalculatorApprovedMessage", {
              attrs: { "parent-class": "financeCalculator__approved--form" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "financeCalculator__finance" },
          [
            !_vm.isInitiallyFetched
              ? _c("FinanceCalculatorQuoteLoading")
              : _vm.isError
              ? _c("FinanceCalculatorNotification")
              : _c("FinanceCalculatorQuote", {
                  attrs: {
                    rate: _vm.quote.rate,
                    term: _vm.quote.term,
                    "total-cost-of-credit": _vm.quote.totalCostOfCredit,
                    "total-funded": _vm.quote.totalFunded,
                    "total-monthly": _vm.quote.totalMonthly,
                    "total-repayment": _vm.quote.totalRepayment,
                  },
                }),
            _vm._v(" "),
            _c("div", { staticClass: "financeCalculator__terms" }, [
              _vm._v(
                "\n                *This is a representative example only\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "financeCalculator__applyButton",
                attrs: { type: "button" },
                on: { click: _vm.toggleApplicationJourneyOverlay },
              },
              [_vm._v("\n                Apply for finance\n            ")]
            ),
            _vm._v(" "),
            _c("FinanceCalculatorApprovedMessage", {
              attrs: { "parent-class": "financeCalculator__approved--finance" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "FinanceApplicationOverlay",
        {
          attrs: { "is-open": _vm.isApplicationOverlayOpen },
          on: { close: _vm.toggleApplicationJourneyOverlay },
        },
        [
          _c("FinanceApplication", {
            attrs: {
              "total-cost-of-credit": _vm.quote.totalCostOfCredit,
              term: _vm.params.term,
              deposit: _vm.params.deposit,
              "total-monthly": _vm.quote.totalMonthly,
              "finance-type": _vm.params.financeType,
              "utm-campaign": _vm.utmCampaign,
              "utm-medium": _vm.utmMedium,
              "utm-source": _vm.utmSource,
            },
            on: { close: _vm.toggleApplicationJourneyOverlay },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }